import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { isGlossaryTab, type GlossaryTab } from '@/features/data/catalog/glossary-api';
import { GlossaryTermPage } from '@/features/data/catalog/glossary-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Un terme du glossaire : résumé, actifs liés (tables et colonnes), définition. `?tab=` dans l'URL. */
export const Route = createFileRoute('/$tenant/glossary/$termId')({
  validateSearch: (search: Record<string, unknown>): { tab?: GlossaryTab } =>
    isGlossaryTab(search['tab']) ? { tab: search['tab'] } : {},
  component: GlossaryTermRoute,
});

function GlossaryTermRoute() {
  const { tenant, termId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="glossary"
      crumbs={[{ label: t('nav.items.glossary') }, { label: termId, mono: true }]}
    >
      <GlossaryTermPage
        tenantId={tenant}
        termId={termId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
